module.exports = __webpack_public_path__ + "img/17.dc300052.png";